/**
 * ReasoningPane — collapsible "Reasoning" section above an assistant
 * message. Streams during the turn; once the response finishes the
 * full reasoning is persisted to mod_ai_chat_messages.reasoning and
 * loads back into the same pane on thread reload.
 *
 * Sprint AI-MODULE v2 AI-17.
 */
import { useState, type FC } from 'react';
import { ChevronDown, ChevronRight, Brain } from 'lucide-react';

interface Props {
  text: string;
  streaming?: boolean;
  defaultOpen?: boolean;
}

const ReasoningPane: FC<Props> = ({ text, streaming, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen || streaming);
  if (!text && !streaming) return null;
  return (
    <div className={'ai-reasoning' + (streaming ? ' is-streaming' : '')}>
      <button
        type="button"
        className="ai-reasoning__toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        <Brain size={14} />
        <span>Reasoning{streaming ? '…' : ''}</span>
      </button>
      {open && (
        <pre className="ai-reasoning__body">{text || '(thinking…)'}</pre>
      )}
    </div>
  );
};

export default ReasoningPane;
